import React, { useState } from "react";
import PropTypes from "prop-types";
import Iframe from "react-iframe";
import styled from "styled-components";
import { Box, Flex, Image, Text, Logo } from "samba-ui";
import PageLoader from "./PageLoader";

const StyledIFrame = styled(Iframe)`
  display: initial;
  position: relative;
  height: 100%;
  width: 100%;
`;

const StyledBox = styled(Box)`
  display: ${p => p.visibility};
  width: 100vw;
  height: 100vh;
`;

const PeriscopeDashboard = ({ id, embedUrl, banner }) => {
  const [loading, setLoading] = useState(true);

  const onLoad = () => {
    setLoading(false);
  };

  return (
    <Box>
      {loading ? <PageLoader /> : null}
      {embedUrl ? (
        <Box>
          {!loading && banner && (
            <Box>
              <Box mx={10} mt={10}>
                <Image height={"50px !important"} src={banner}></Image>
              </Box>
              <Flex ml={4} mb={2} alignItems="center">
                <Text fontSize={0} fontWeight={500} mr={1}>
                  True Reach & Frequency powered by
                </Text>
                <Logo.WithText color="alert" height={20} />
              </Flex>
            </Box>
          )}

          <StyledBox visibility={!loading ? "auto" : "none"}>
            <StyledIFrame url={embedUrl} onLoad={onLoad} />
          </StyledBox>
        </Box>
      ) : null}
    </Box>
  );
};

PeriscopeDashboard.propTypes = {
  id: PropTypes.number
};

export default PeriscopeDashboard;
